module.exports = __webpack_public_path__ + "static/1183908006.65084470.jpg";